import React from "react";
import { Quote, Star } from "lucide-react";
import { Section, SectionHeader } from "../../../components/ui/section";
import { cn } from "../../../lib/utils";
import { CONTRACTOR_SURFACE_RADIUS_LG_CLASS } from "../layoutRadius";
import type { Testimonial } from "../types";

type TestimonialsSectionProps = {
  testimonials: Testimonial[];
};

export const TestimonialsSection: React.FC<TestimonialsSectionProps> = ({
  testimonials,
}) =>
  testimonials.length > 0 ? (
    <Section id="testimonials" className="bg-muted/40">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <SectionHeader
          center
          className="mb-16"
          kicker="Testimonials"
          title="What our clients say"
          description="Feedback from local customers who hired us for their projects."
        />

        <ul className="grid gap-6 md:grid-cols-2">
          {testimonials.map((testimonial) => (
            <li key={`${testimonial.name}-${testimonial.quote}`}>
              <div
                className={cn(
                  "border border-border bg-card p-6 transition-all duration-300 hover:border-accent/30 hover:shadow-card sm:p-8",
                  CONTRACTOR_SURFACE_RADIUS_LG_CLASS,
                )}
              >
                <div className="mb-5 flex items-start justify-between">
                  <div className="flex gap-1">
                    {[...Array(5)].map((_, index) => (
                      <Star
                        key={index}
                        className="h-4 w-4 fill-accent text-accent"
                      />
                    ))}
                  </div>
                  <Quote className="h-8 w-8 text-accent/25" />
                </div>
                <p className="mb-6 text-sm leading-relaxed text-muted-foreground">
                  &quot;{testimonial.quote}&quot;
                </p>
                <div className="flex items-center gap-3">
                  <div className="flex h-10 w-10 items-center justify-center rounded-full bg-linear-to-br from-primary to-accent">
                    <span className="text-sm font-semibold text-primary-foreground">
                      {testimonial.name.charAt(0)}
                    </span>
                  </div>
                  <div>
                    <div className="font-display text-sm font-semibold text-foreground">
                      {testimonial.name}
                    </div>
                    <div className="text-xs text-muted-foreground">
                      {testimonial.location}
                    </div>
                  </div>
                </div>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </Section>
  ) : null;
